import type { ComponentStyleConfig } from '@chakra-ui/theme';

const ToggleTheme: ComponentStyleConfig = {
  variants: {
    fixed: {
      form: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: '24',
      },
    },
    dynamic: {
      form: {
        flexDirection: 'column',
        display: 'flex',
      },
    },
  },
  sizes: {
    sm: {
      container: {
        width: '1.75rem',
      },
      skeleton: {
        width: '1.75rem',
        height: '16',
      },
      thumb: {
        height: '12',
        width: '12',
        _checked: {
          transform: 'translate(12px)',
        },
      },
      track: {
        height: '16',
        width: '1.75rem',
        _after: {
          backgroundSize: '16px 16px',
          backgroundPositionX: '-0.1rem',
        },
        _before: {
          backgroundPositionX: '0',
          backgroundSize: '16px 16px',
        },
      },
    },
  },
  baseStyle: ({ isReadOnly }) => {
    return {
      skeleton: {
        width: isReadOnly ? '40' : '3rem',
        borderRadius: isReadOnly ? '4' : '12',
        height: '24',
      },
      valueText: {
        textStyle: 'body/lg/regular',
        '[data-disabled] &': {
          color: 'text.disabled',
          cursor: 'not-allowed',
        },
      },
      form: {
        _disabled: { cursor: 'not-allowed' },
      },
      helperText: {
        color: 'input/text/helper',
        '[data-disabled] &': {
          color: 'text.disabled',
          cursor: 'not-allowed',
        },
      },
      container: {
        position: 'relative',
        width: '3rem',
      },
      label: {
        fontStyle: 'comp/input/label',
        marginBottom: '4',
      },
      spinner: {
        color: 'neutral.70',
        flexShrink: 0,
        height: '16',
        marginTop: '4',
        width: '16',
      },
      thumb: {
        _checked: {
          transform: 'translate(24px)',
        },
        backgroundColor: 'input/toggle/slideOn',
        borderRadius: '24',
        height: '1.25rem',
        position: 'relative',
        transition: '100ms',
        width: '1.25rem',
        zIndex: '1',
      },
      track: {
        _after: {
          backgroundImage:
            `/* @see: https://github.com/chakra-ui/chakra-ui/issues/7548#issuecomment-1684034030 */` +
            `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12.01 10.608 16.618 6l1.402 1.402-4.608 4.608 4.608 4.608-1.402 1.402-4.608-4.608-4.608 4.608L6 16.618l4.608-4.608L6 7.402 7.402 6l4.608 4.608Z' fill='white' /%3E%3C/svg%3E"),` +
            `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12.01 10.608 16.618 6l1.402 1.402-4.608 4.608 4.608 4.608-1.402 1.402-4.608-4.608-4.608 4.608L6 16.618l4.608-4.608L6 7.402 7.402 6l4.608 4.608Z' fill='white' /%3E%3C/svg%3E")`,
          backgroundPositionX: '-0.125rem',
          backgroundSize: '24px 24px',
          bottom: 0,
          content: '""',
          left: '50%',
          position: 'absolute',
          right: 0,
          top: 0,
        },
        _before: {
          backgroundImage:
            `/* @see: https://github.com/chakra-ui/chakra-ui/issues/7548#issuecomment-1684034030 */` +
            `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M18.7372 7.67567L10.7502 16.3887L5.34921 11.7592L6.6508 10.2407L10.5831 13.6112L17.2628 6.32422L18.7372 7.67567Z' fill='white' /%3E%3C/svg%3E"),` +
            `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M18.7372 7.67567L10.7502 16.3887L5.34921 11.7592L6.6508 10.2407L10.5831 13.6112L17.2628 6.32422L18.7372 7.67567Z' fill='white' /%3E%3C/svg%3E")`,
          backgroundPositionX: '0.125rem',
          backgroundSize: '24px 24px',
          bottom: 0,
          content: '""',
          left: 0,
          position: 'absolute',
          right: '50%',
          top: 0,
        },
        _checked: {
          _disabled: {
            backgroundColor: 'input/toggle/frameOn-disabled',
          },
          backgroundColor: 'input/toggle/frameOn',
        },
        _disabled: {
          backgroundColor: 'input/toggle/frameOff-disabled',
          cursor: 'not-allowed',
        },
        _focusVisible: {
          boxShadow: 'outline',
        },
        backgroundColor: 'input/toggle/frameOff',
        borderRadius: '12',
        boxSizing: 'border-box',
        height: '24',
        isolation: 'isolate',
        padding: '0.125rem',
        transition: '100ms',
        width: '48',
      },
    };
  },
};

export default ToggleTheme;
